<template>
  <div class="material-management-image material-management-common">
    <template v-if="!uploadShow">
      <div class="nav">
        <div class="nav-up">
          <div class="query-bar">
            <div class="query-left">
              <el-form inline>
                <el-form-item label="公众号:">
                  <el-select
                    v-model="publicSelect"
                    class="select"
                    placeholder="请选择"
                    :clearable="true"
                  >
                    <template v-for="item in publicList">
                      <el-option
                        :key="item.app_id"
                        :label="item.app_name"
                        :value="{ value: item.app_id, label: item.app_name }"
                      />
                    </template>
                  </el-select>
                </el-form-item>
                <el-form-item label="企业微信应用:">
                  <el-select
                    v-model="agentSelect"
                    class="select"
                    placeholder="请选择"
                    :clearable="true"
                  >
                    <template v-for="item in agentList">
                      <el-option
                        :key="item.agent_id"
                        :label="item.agent_name"
                        :value="{ value: item.agent_id, label: item.agent_name }"
                      />
                    </template>
                  </el-select>
                </el-form-item>
                <el-form-item label="图片名称:">
                  <el-input v-model="search" placeholder="请输入" clearable></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="query-right">
              <el-button type="primary" @click="handleSearch">筛选</el-button>
              <el-button type="primary" class="upload-btn" @click="handleUpload(file_type)">
                上传
              </el-button>
            </div>
          </div>
        </div>
        <div class="nav-down">
          <span class="img-text">图片(共{{ tableTotal }}条)</span>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%" v-loading="tableLoading">
        <el-table-column label="名称" width="300">
          <template slot-scope="scope">
            <div class="title">
              <img
                :src="scope.row.cos_url"
                alt="#"
                class="table-img"
                @click="handlePlay(scope.row.cos_url)"
              />
              <el-input v-show="scope.row.show" v-model="scope.row.prefix" :maxlength="100">
                <template slot="append">{{ scope.row.postfix }}</template>
              </el-input>
              <span v-show="!scope.row.show">{{ scope.row.mate_name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="适用公众号">
          <template slot-scope="scope">
            <DeleteTag
              :row="scope.row"
              @emitDeleteTagDec="emitDeleteTagDec"
              @emitDeleteTagAdd="emitDeleteTagAdd"
            />
          </template>
        </el-table-column>
        <el-table-column label="适用企业微信应用">
          <template slot-scope="scope">
            <DeleteTag2
              :row="scope.row"
              @emitDeleteTagDec="emitDeleteTagDec2"
              @emitDeleteTagAdd="emitDeleteTagAdd2"
            ></DeleteTag2>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span v-show="!scope.row.show" class="action">
              <a
                href="#"
                @click="actionFun({ action: '修改', row: scope.row })"
                style="margin-right: 5px"
              >
                修改
              </a>
              <a
                href="#"
                @click="
                  () => {
                    delDialogVisible = true;
                    rowTemp = scope.row;
                  }
                "
              >
                删除
              </a>
            </span>
            <span v-show="scope.row.show" class="action">
              <a
                href="#"
                @click="actionFun({ action: '保存', row: scope.row })"
                style="margin-right: 5px"
              >
                保存
              </a>
              <a href="#" @click="actionFun({ action: '取消', row: scope.row })">取消</a>
            </span>
            <Clipboard
              :copytext="String(scope.row.mate_data)"
              v-show="!scope.row.show"
              class="action"
            >
              <a href="#">复制链接</a>
            </Clipboard>
          </template>
        </el-table-column>
        <div slot="empty"><NoData></NoData></div>
      </el-table>
      <el-dialog title="" :visible.sync="delDialogVisible" width="30%" center>
        <span>确定删除此素材吗?</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="delDialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="
              () => {
                delDialogVisible = false;
                actionFun({ action: '删除', row: rowTemp });
              }
            "
          >
            确 定
          </el-button>
        </span>
      </el-dialog>
      <el-pagination
        class="pagination"
        style="background-color: #ffffff"
        :current-page="tableCurPage"
        :page-size="tablePageSize"
        :total="tableTotal"
        @current-change="currentChangeFun"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="g_pageSizesConfig"
        @size-change="handleSizeChange"
      />
    </template>
    <!-- 图片上传 -->
    <MaterialImgUpload
      v-if="uploadShow"
      @emitMaterialUpload="emitMaterialUpload"
      @emitDeleteTagDec="emitDeleteTagDec"
    />
    <!-- 音频播放 -->
    <el-dialog title="" :visible.sync="playDialogVisible" width="30%" :before-close="handleClose">
      <img id="play" :src="playSrc" style="width: 100%; max-height: 500px" />
    </el-dialog>
  </div>
</template>
<script>
import NoData from '@/components/no-data';
import Clipboard from '@/components/Clipboard';
import MaterialImgUpload from '@/components/material-img-upload';
import DeleteTag from '../components/delete-tag';
import DeleteTag2 from '../components/delete-tag2';
import { mixinTable } from '../../mixin/table.js';
import { CosMixin } from '@/mixins/cos.js';
export default {
  name: 'MaterialManagementImage',
  components: {
    NoData,
    MaterialImgUpload,
    DeleteTag,
    DeleteTag2,
    Clipboard,
  },
  mixins: [mixinTable, CosMixin],
  data() {
    return {
      file_type: 1,
    };
  },
  created() {
    // 设置面包屑
    const breadcrumb = [
      { menu_name: '发布管理', menu_path: '' },
      {
        menu_name: '素材库管理',
        menu_path: '',
      },
      { menu_name: '图片' },
    ];

    this.$store.commit('user/setBreadcrumb', breadcrumb);
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.material-management-image {
  //
}
</style>
